import { Mail, MapPin, Phone, Twitter, Linkedin, Github, Facebook } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const navigate = useNavigate();

    const footerLinks = {
        products: [
            { name: 'Daily Deposit', href: '#products' },
            { name: 'Recurring Deposit', href: '#services' },
            { name: 'Fixed Deposit', href: '#services' },
            { name: 'Monthly Interrst Scheme', href: '#services' },
            { name: 'Saving Deposit', href: '#services' }
        ],
        company: [
            { name: 'About Us', href: '#about' },
            { name: 'Our Team', href: '#about' },
            { name: 'Careers', href: '#' },
            { name: 'Contact', href: '#contact' }
        ],
        resources: [
            { name: 'Blog', href: '#' },
            { name: 'Documentation', href: '#' },
            { name: 'Support', href: '#' },
        ]
    };

    const socialLinks = [
        { icon: Twitter, href: '#', name: 'Twitter' },
        { icon: Linkedin, href: '#', name: 'LinkedIn' },
        { icon: Github, href: '#', name: 'GitHub' },
        { icon: Facebook, href: '#', name: 'Facebook' }
    ];


    return (


        <footer className="bg-gray-800 text-white ">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-8">
                    <div className="lg:col-span-2">
                        <div className="flex items-center space-x-2 mb-4">
                            <div className="">
                                <img src='./logo.png' className='w-8 h-8' />
                            </div>
                            <span className="text-xl font-bold">sagwara Mahila Bachat Samiti</span>
                        </div>
                        <p className="text-gray-400 mb-6 leading-relaxed">
                            Sagwara Apni Bachat Ghar Mahila Sahakari Samiti Limited.
                        </p>
                        <div className="space-y-2">
                            <div className="flex items-center space-x-3 text-gray-400">
                                <Mail className="w-4 h-4" />
                                <span className="text-sm">sagwaranidhilimited@gmail.com</span>
                            </div>
                            <div className="flex items-center space-x-3 text-gray-400">
                                <Phone className="w-4 h-4" />
                                <span className="text-sm">+91 94145 67638</span>
                            </div>
                            <div className="flex items-start space-x-3 text-gray-400">
                                <MapPin className="w-4 h-4" />
                                <span className="text-sm">Ward No 27 Sagwara<br />
                                    Dungarpur, Rajasthan - 314025</span>
                            </div>
                        </div>
                    </div>



                    <div>
                        <h3 className="text-lg font-semibold mb-4">Products</h3>
                        <ul className="space-y-2">
                            {footerLinks.products.map((link, index) => (
                                <li key={index}>
                                    <button
                                        onClick={() => scrollToSection('products')}
                                        className="text-gray-400 hover:text-white transition-colors text-sm"
                                    >
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Company</h3>
                        <ul className="space-y-2">
                            {footerLinks.company.map((link, index) => (
                                <li key={index}>
                                    <button
                                        onClick={() => scrollToSection(link.href.replace('#', ''))}
                                        className="text-gray-400 hover:text-white transition-colors text-sm"
                                    >
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Resources</h3>
                        <ul className="space-y-2">
                            <li>
                                <p onClick={() => navigate('privacy-policy')} className="cursor-pointer text-gray-400 hover:text-white transition-colors text-sm">
                                    Privacy Policy
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-12 pt-8">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center">
                            <p className="text-sm">
                                © {currentYear} Sagwara Apni Bachat Ghar Mahila Sahakari Samiti Limited.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
